import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/Shared/Button'

import { Card } from 'react-bootstrap'
import { Trans } from 'react-i18next'

const FailedScreen = ({ title }) => {
  return (
    <Card className="card card-default w-100 package-builder-page_loading-error-message">
      <div className="package-builder-page_loading-screen_inner">
        <p className="mb-3">
          <Trans i18nKey="PackageBuilder.failed">
          Your Package <strong>{{ title }}</strong> failed to build.
          </Trans>
        </p>
        
        <Button text={'Retry'} linkTo="/package-builder/create" className="w-100" />
      </div>
    </Card>
  )
}

FailedScreen.propTypes = {
  title: PropTypes.string,
}

export default FailedScreen
